import { queryOptions } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { Join } from "@/pages/participant/join";

type ParticipantSession = {
  lang: "sv" | "en";
};

const userSessionQueryOptions = (session_token: string) => {
  const url = new URL(`https://${window.location.host}/api/participant/session`);
  url.searchParams.set("token", session_token);
  return queryOptions<ParticipantSession>({
    queryKey: ["participant", "session", session_token],
    queryFn: () => {
      return fetch(url, {
        headers: { "content-type": "application/json" },
      }).then((res) => res.json());
    },
  });
};

export const Route = createFileRoute("/participate/$session_token/join")({
  component: Join,
  loader: ({ context: { queryClient }, params: { session_token } }) => {
    return queryClient.ensureQueryData(userSessionQueryOptions(session_token));
  },
});
